
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { ChangeEventHandler } from "react";

type ModalProps = {
  value: string;
  changeEvent: ChangeEventHandler<HTMLInputElement>;
};

const Search = ({ value, changeEvent }: ModalProps) => {
  return (
    <div>
      <TextField
        type="text"
        id="search-textfield"
        value={value}
        onChange={changeEvent}
        placeholder="Start typing here to search"
        fullWidth
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
            </InputAdornment>
          ),
        }}
      />
    </div>
  );
};

export default Search;